module.exports = __webpack_public_path__ + "6d6ccbf3e99de06b2dd8cce5f3f379fd.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/pricing_b2b.svg
// module id = 1252
// module chunks = 65